import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IResultado } from '../index';
import { HttpClient2 } from './http-client.service';

//Clases
import { Viaje } from '../models';

//Otros
import { TransbordoDTO } from '@shared/dto';
import { FacturacionEmpresaTransporteDTO } from '@shared/dto/facturacionEmpresaTransporte.dto';
import { MiniViajeDTO } from '@shared/dto/mini-viaje.dto';
import { ViajeConsolidado, ViajeConsolidadoDetalle } from '@shared/models/viajeConsolidado';
import { Observable, throwError } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { catchError, map } from 'rxjs/operators';
import { ResponseViajeFiltrosDTO } from 'src/app/layout/control/estados-viaje/resources/dto/responseViajeFiltros.dto';
import { ResultadoFiltrosDTO } from 'src/app/layout/control/estados-viaje/resources/dto/resultadoFiltro.dto';
import { ImportarViajeDTO } from '../dto/importarViaje.dto';

@Injectable()
export class ViajeService {
  ciaId: string;
  usuarioId: string;
  constructor(private http: HttpClient2) {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.ciaId = "/" + currentUser.compania.companiaId;
    this.usuarioId = "" + currentUser.usuarioId;
  }

  consultar(viaje: any): Observable<Array<Viaje>> {
    viaje.usuarioId = this.usuarioId;
    return this.http.consultar(this.ciaId + '/viajes/consultar', viaje).map(
      (data: IResultado) => {
        let list = Array<Viaje>();
        let obj;
        if (data) {
          for (const d of data.resultado) {
            obj = new Viaje();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
      });
  }

  obtenerPorFechaRealInicio(viaje: any): Observable<Array<Viaje>> {
    return this.http.consultar(this.ciaId + '/viajes/obtener-por-fecha-real-inicio', viaje).map(
      (data: IResultado) => {
        let list = Array<Viaje>();
        let obj;
        if (data) {
          for (const d of data.resultado) {
            obj = new Viaje();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
      });
  }

  obtenerViajeRecojo(viaje: any): Observable<Array<Viaje>> {
    return this.http.consultar(this.ciaId + '/viajes/viajes-recojos', viaje).map(
      (data: IResultado) => {
        let list = Array<Viaje>();
        let obj;
        if (data) {
          for (const d of data.resultado) {
            obj = new Viaje();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
      });
  }

  obtenerViajesConsolidado(httpParams: HttpParams): Observable<ViajeConsolidado[]> {
     return this.http.obtener(this.ciaId + '/viajes/consolidados/viaje-consolidados', { params: httpParams }).map(
      (data: any) => {
        return data;
      });
  }

  obtenerViajesConsolidadoDetalle(id): Observable<ViajeConsolidadoDetalle[]> {
     return this.http.obtener(this.ciaId + '/viajes/obtener-viaje-consolidado-detalle/'+id).map(
      (data: any) => {
        return data;
      });
  }

  obtenerViajeConsolidado(viajeConsolidadoId: any): Observable<ViajeConsolidado> {
    return this.http.obtener(this.ciaId + '/viajes/obtener-consolidado-viaje/' + viajeConsolidadoId).map(
      (data: IResultado) => {
        let viajeConsolidado: ViajeConsolidado;
        viajeConsolidado = data.resultado;
        return viajeConsolidado;
      });
  }

  listarViajeConsolidado(): Observable<ViajeConsolidado[]> {
     return this.http.obtener(this.ciaId + '/viajes/viaje-consolidados').map(
      (data: IResultado) => {
        return data.resultado;
      });
  }

  registrar(viaje: Viaje, httpParams: HttpParams, funcionalidad?: string) {
    return this.http.registrar(this.ciaId + '/viajes', viaje, { params: httpParams, funcionalidad });
  }

  registrarConsolidado(viajeConsolidado, usuarioId) {
    return this.http.registrar(this.ciaId + '/viajes/' + usuarioId +'/consolidado', viajeConsolidado);
  }

  registrarImportacion(listImportarViajeDTO: Array<ImportarViajeDTO>, companiaId?: string, funcionalidad?: string) {
    if (companiaId == undefined) companiaId = this.ciaId;
    return this.http.registrar(companiaId + "/viajes/registrar-importacion?usuarioId=" + this.usuarioId, listImportarViajeDTO, { funcionalidad });
  }

  modificarParcial(viaje: Viaje, httpParams: HttpParams, funcionalidad?: string) {
    return this.http.modificarParcial(this.ciaId + '/viajes', viaje, { params: httpParams, funcionalidad });
  }

  modificar(viaje: Viaje, httpParams: HttpParams, funcionalidad?: string, usuarioIdAuditoria?: number) {
    return this.http.modificar(this.ciaId + '/viajes', viaje, { params: httpParams, funcionalidad, usuarioIdAuditoria });
  }

  modificarViajeConsolidado(viajeConsolidado, usuarioId) {
    return this.http.modificar(this.ciaId + '/viajes/consolidado?usuarioId='+ usuarioId + '&isRecalcular=false', viajeConsolidado);
  }

  modificarViajeEmpresaTransporte(objeto, httpParams: HttpParams) {
    let currentUser  = JSON.parse(localStorage.getItem("currentUser"));
    var ciaId = currentUser.esEmpresaTransporteAdministrador? currentUser?.companiaPadre: currentUser.compania.companiaId;
    return this.http.modificarViajeEmpresaTransporte("/" + ciaId + '/viajes/modificar-viaje-empresa-transporte', objeto, { params: httpParams });
  }

  eliminar(viajesId: String, funcionalidad?: string, usuarioIdAuditoria?: number) {
    return this.http.eliminar(this.ciaId + '/viajes/' + viajesId, { funcionalidad, usuarioIdAuditoria });
  }

  eliminarConsolidado(viajeConsolidadoId: String) {
    return this.http.eliminar(this.ciaId + '/viajes/consolidado/' + viajeConsolidadoId);
  }

  eliminarDevolucion(viajeId: number, httpParams: HttpParams, funcionalidad?: string) {
    return this.http.eliminar(this.ciaId + '/viajes/' + viajeId+ '/eliminar-devolucion', { params: httpParams, funcionalidad });
  }

  obtener(viajeId: number): Observable<Viaje> {

    return this.http.obtener(this.ciaId + '/viajes/' + viajeId).map(
      (data: IResultado) => {
        let obj = new Viaje();
        if (data) {
          obj.copiar(data.resultado);
        }
        return obj;
      });

  }

  obtenerViajeAlmacen(viajeId: number): Observable<Viaje> {

    return this.http.obtener(this.ciaId + '/viajes/obtener-viaje-almacen/' + viajeId).map(
      (data: IResultado) => {
        let obj = new Viaje();
        if (data) {
          obj.copiar(data.resultado);
        }
        return obj;
      });

  }

  obtenerViajeDevolucion(viajeId: number): Observable<any> {

    return this.http.obtener(this.ciaId + '/viajes/obtener-viaje-devolucion/' + viajeId).map(
      (data: IResultado) => {
        return data.resultado;
      });

  }
  obtenerEmpresaTransporteFacturacion(): Observable<Array<FacturacionEmpresaTransporteDTO>>{
    return this.http.obtener(this.ciaId+'/viajes/obtener-empresa-transporte-facturacion').map(
      (data: IResultado) => {
        return data.resultado;
    });
  }

  consolidar(params: any) {
    return this.http.modificar(this.ciaId + "/viajes/consolidar", params);
  }

  //Control de Estados
  listarProgresoEstados(httpParams: HttpParams) {
    //Setaear Usuario
    httpParams = httpParams.append("usuarioId", this.usuarioId);
    return this.http.listar(this.ciaId + '/viajes/no-finalizados', { params: httpParams });
  }

  listarNoFinalizados(params?: HttpParams): Observable<ResponseViajeFiltrosDTO> {
    return this.http.listar(this.ciaId + '/viajes/no-finalizados', { params: params }).pipe(
      map((data: IResultado) => {
        const response = new ResponseViajeFiltrosDTO();
        response.listado = (data.resultado?.listado || []).map((d: any) => {
          const v = new Viaje();
          v.copiar(d);
          return v;
        });
        response.filtros = Object.assign(new ResultadoFiltrosDTO(), data.resultado?.filtros);
        return response;
      }),
      catchError((error) => {
        console.error('Error al obtener viajes no finalizados:', error);
        return throwError(() => error);
      })
    );
  }

  obtenerViajeAndPuntos(viajeId: number): Observable<Viaje> {

    return this.http.get(this.ciaId + '/viajes/' + viajeId + '/puntos-visita')
      .map(response => {
        switch (response.status) {
          case 200:
            return response.json().resultado;
          default:
            let json = response.json();
            console.log(json.excepcion);
            return [];
        }
      })
      .catch(response => {
        let json = response.json();
        console.log(json.excepcion);
        return [];
        //return Observable.throw(json.mensaje || 'Server error'); // Observable.throw() is undefined at runtime using Webpack
      });

  }

  gestionAlmacenIntermedio(): Observable<any> {
    return this.http.listar(this.ciaId + '/viajes/gestion-almacen-intermedio').map(
      (data: IResultado) => {
        let list = Array<any>();
        let obj;
        for (const d of data.resultado) {

          list.push(d);
        }
        return list;
      });

  }

  consultarSensores(dataSensores): Observable<any> {
    const payload = {...dataSensores, vehiculoId: null};
    return this.http.consultar('/viajes/sensores/consultar', payload).map(
      (data: IResultado) => {
        let list = Array<any>();
        if (data) {
          for (const d of data.resultado) {
            list.push(d);
          }
        }
        return list;
      });

  }

  consultarSensoresSegunUnidadTransporte(dataSensores): Observable<any> {
    const payload = {...dataSensores, vehiculoId: null};
    return this.http.consultar('/viajes/sensores/consultar/unidad-transporte', payload).map(
      (data: IResultado) => {
        let list = Array<any>();
        if (data) {
          for (const d of data.resultado) {
            list.push(d);
          }
        }
        return list;
      });

  }

  //Listar viajes devolucion
  consultarViajeDevolucion(httpParams: HttpParams) {
    return this.http.listar(this.ciaId + '/viajes/devoluciones', { params: httpParams });
  }

  //Registrar o editar viajes devolucion
  addOrEdit(viaje: Viaje, httpParams: HttpParams, funcionalidad?: string){
    if (viaje.viajeId) {
      return this.http.modificar(this.ciaId + '/viajes/modificar-devolucion', viaje, { params: httpParams, funcionalidad });
    } else {
      return this.http.registrar(this.ciaId + '/viajes/registrar-devolucion', viaje, { params: httpParams, funcionalidad });
    }
  }

  generarTransbordo(payload: TransbordoDTO, funcionalidad?: string, usuarioIdAuditoria?: number): Observable<any> {
    const _payload = {
      ...payload,
      tareasId: [...payload.tareasId]
    };

    return this.http.registrar(this.ciaId + '/viajes/transbordo', _payload, { funcionalidad, usuarioIdAuditoria }).map(
      (data: IResultado) => {
        return data;
      }
    )
  }

  getAlmacenesViaje(viajeIds: Array<number>){
    return this.http.obtener(`${this.ciaId}/viajes/${viajeIds}/viaje-almacen`).map(
      (data:IResultado) => {
        let viaje : Array<Viaje> = [];
        if (data) {
          viaje = data.resultado;
        }
        return viaje;
      }
    )
  }

  obtenerHeaders(httpOptions?: Object): HttpHeaders {
    return this.http.obtenerHeaders();
  }


  listar(): Observable<Array<Viaje>>{
    return this.http.listar(this.ciaId+"/viajes").map(
      (data: IResultado) => {
        let list = Array<Viaje>();
        let obj;
        if(data){
          for (const d of data.resultado) {
            obj = new Viaje();
            obj.copiar(d);
            list.push(obj);
          }
        }
        return list;
    });
  }

  obtenerViajeConPvPadre(viajeId: number): Observable<Viaje> {

    return this.http.obtener(this.ciaId + '/viajes/' + viajeId + "/con-punto-visita-padre").map(
      (data: IResultado) => {
        let obj = new Viaje();
        if (data) {
          obj.copiar(data.resultado);
        }
        return obj;
      });

  }

  registrarMiniViaje(listImportarViajeDTO: Array<MiniViajeDTO>, companiaId?: string, funcionalidad?: string) {
    if (companiaId == undefined) companiaId = this.ciaId;
    return this.http.registrar(companiaId + "/viajes/crear-mini-viaje-web?usuarioId=" + this.usuarioId, listImportarViajeDTO, { funcionalidad });
  }

  obtenerTareaEvidencia(tareaId: number){
    return this.http.obtener('/tareas-evidencia/'+tareaId).map(
      (data: IResultado) => {
        let list = Array<any>();
        list = data.resultado;
        return list;
      });
  }


  confirmarTodos(body: any): Observable<any> {

    return this.http.consultar('/liquidacion-productos/confirmar-todos', body).map(
      (data: IResultado) => {
        return data.data;
      });

  }

  listarLogs(viajeId): Observable<Array<any>>{
    return this.http.listar('/viajes/' + viajeId + '/obtener-viaje-logs').map(
      (data: IResultado) => {
        let list = Array<any>();
        if(data){
          for (const d of data.resultado) {
            list.push(d);
          }
        }
        return list;
    });
  }
}
